import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController, ToastController } from '@ionic/angular';
import { AppSettings } from "src/app/app-settings";
import { AddOtComponent } from 'src/app/components/add-ot/add-ot.component';
import { OfftopicService } from 'src/app/api/offtopic.service';

@Component({
  selector: 'app-offtopic',
  templateUrl: './offtopic.page.html',
  styleUrls: ['./offtopic.page.scss'],
})
export class OfftopicPage implements OnInit {

  isWeb = AppSettings.IS_WEB;
  isOTMailThreadDisplay = true;
  subject: any;    //to display as heading in 
  items: any[] = [];
  childItems: any;  //when we expand
  allchildItems: any; //when we click on particullar one to view all OT's
  searchTerm: string = '';
  isAdmin: boolean = false;
  private isToastShowing = false; //show toast

  //For Pagination I am using below 4 variables 
  currentPage = 1;
  totalPages = 0;
  isLoading = true;
  count = 0;
  searchResultsFound: boolean = true;
  showReply: { [key: string]: boolean } = {};

  constructor(private modalController: ModalController, private offtopicService: OfftopicService, private alertController: AlertController, private toastController: ToastController) {

  }

  ngOnInit() {
    this.isAdminOrNot();
  }

  ionViewDidEnter() {
    this.searchTerm = '';
    this.getHierarchyMails();
  }

  //  currently selected item for expand 
  selectedItem: any;


  isAdminOrNot() {
    this.offtopicService.isAdmin().then((response) => {
      this.isAdmin = response.is_SuperUser;
    }).catch((error) => { })
  }

  //  to collapse the other item or if we click on the same item that expanded it will closes that item Too 
  toggleExpand(item: any) {
    if (this.selectedItem === item) {
      item.expanded = false;
      this.selectedItem = null;
    } else {
      if (this.selectedItem) {
        this.selectedItem.expanded = false;
      }
      item.expanded = true;
      this.selectedItem = item;
    }
  }

  toggleChilds(item) {
    item.isExpanded = !item.isExpanded;
  }

  async addNewModal(threadid?: any, otid?: number, subject?: any, CreatedBy?: any) {
    if (typeof otid !== undefined && typeof CreatedBy !== undefined) {
      const modal = await this.modalController.create({
        component: AddOtComponent,
        componentProps: {
          sendTo: CreatedBy,
          parentOTId: otid,
          threadId: threadid,
          subject: subject
        }
      });
      await modal.present();
      await modal.onDidDismiss()
        .then((response: any) => {
          if (response.data == 'failure') {
            this.isOTMailThreadDisplay = !this.isOTMailThreadDisplay;
          }
          this.getHierarchyMails();
          this.getAllChildMails(threadid);
        });
    }
    else if (typeof otid !== undefined) {
      const modal = await this.modalController.create({
        component: AddOtComponent,
        componentProps: {
          parentOTId: otid,
          threadId: threadid,
          subject: subject
        },

      });
      await modal.present();
      await modal.onDidDismiss().then((response: any) => {
        if (response.data == 'failure') {
          this.isOTMailThreadDisplay = !this.isOTMailThreadDisplay;
        }
        this.getHierarchyMails();
        this.getAllChildMails(threadid);
      });
    }
    else {
      const modal = await this.modalController.create({
        component: AddOtComponent
      });
      await modal.present();
      await modal.onDidDismiss().then((response) => {
        if (response.data == 'failure') {
          this.isOTMailThreadDisplay = !this.isOTMailThreadDisplay;
        }
        this.getHierarchyMails();
      });
    }
  }


  getHierarchyMails(event?: any, searchTerm: string = '') {
    // this.searchTerm = '';
    this.searchResultsFound = true;
    this.isLoading = true;
    this.currentPage = 1;
    this.items = [];
    this.totalPages = 0;
    this.offtopicService.getHierarchyMails(this.currentPage, searchTerm)
      .then((response) => {
        this.isLoading = false;
        this.items = response.results;
        this.totalPages = response.total_pages;
        this.count = response.count;
        this.searchResultsFound = this.items.length > 0;
        this.items.forEach((item) => {
          item.expanded = false;
          item.color = this.intToRGB(this.hashCode(item.CreatedBy));
        });
        if (event) {
          event.target.complete();
        }
      })
      .catch((error) => {
        this.isLoading = false;
        if (event) {
          event.target.complete();
        }
        console.error("Error in getHierarchyMails:", error);  // Log the error
      })
      .finally(() => {
        if (event) {
          event.target.complete();
        }
      });
  }


  loadData(event: any) {
    this.currentPage++;
    if (this.items.length < this.count) {
      this.offtopicService.getHierarchyMails(this.currentPage, this.searchTerm)
        .then((response) => {
          this.items = this.items.concat(response.results);
          event.target.complete();
          this.totalPages = response.total_pages;
          this.count = response.count;
          this.items.forEach((item) => {
            item.expanded = false;
            item.color = this.intToRGB(this.hashCode(item.CreatedBy))
          });
          if (this.items.length >= response.count) {
            event.target.disabled = true;
          }
        })
        .catch((error) => {
          event.target.disabled = true;
          event.target.complete();
        }).finally(() => {
          event.target.complete();
        })
    }
    else {
      event.target.disabled = true;
      event.target.complete();
    }
  }


  getAllChildMails(threadid) {
    this.allchildItems = [];
    this.offtopicService.getHierarchyMails(1, '', threadid).then((response) => {
      this.allchildItems = response
      this.allchildItems = this.allchildItems.map(x => {
        x.color = this.intToRGB(this.hashCode(x.CreatedBy))
        return x;
      })
    }).catch((error) => {
    })
  }

  getChildMails(threadid, otid) {
    this.childItems = []
    this.offtopicService.getHierarchyMails(1, '', threadid, otid).then((response) => {
      this.childItems = response
      this.childItems = this.childItems.map(x => {
        x.color = this.intToRGB(this.hashCode(x.CreatedBy))
        return x;
      })
    }).catch((error) => {
    })
  }

  updateReadBy(otid) {
    this.offtopicService.updateOffTopicReadBy(otid).then((response) => {
      this.getHierarchyMails();
    }).catch((error) => {
    })

  }

  private hashCode(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
  }

  private intToRGB(i) {
    let c = (i & 0x00FFFFFF).toString(16).toUpperCase();
    return '#' + '00000'.substring(0, 6 - c.length) + c;
  }


  doRefresh(event) {
    setTimeout(() => {
      this.items = []
      this.currentPage = 0;
      this.searchTerm = '';
      this.searchResultsFound = true;
      this.getHierarchyMails(event);
    }, 0);
  }


  assignSubject(subject?: any) {
    if (subject !== undefined) {
      this.subject = subject;
    }
    else this.subject = '';
  }


  async showDeleteOptions(item) {
    const alert = await this.alertController.create({
      header: 'Delete',
      message: 'Do you want to delete the entire thread or just this message?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Delete',
          handler: () => {
            this.offtopicService.deleteOtThread(item.otid).then((response) => {
              this.presentToast('OffTopic deleted ', 'danger');
              //
              //for local deletion without doing get api call 
              //

              let index = this.items.findIndex(x => x.otid == response.otid)
              if (index !== -1) {
                this.items.splice(index, 1);
              }

            }).catch((error) => { });
          }
        },

      ]
    });

    await alert.present();
  }


  async presentToast(message: string, color) {
    if (this.isToastShowing) {
      return;
    }
    const toast = await this.toastController.create({
      message: message,
      duration: 2000,
      position: 'top',
      color: color,
      cssClass: 'my-toast-class'
    });

    this.isToastShowing = true;
    toast.present();
    await toast.onDidDismiss();
    this.isToastShowing = false;
  }

  searchFilter(evt) {
    this.searchTerm = evt.srcElement.value;
    if (this.searchTerm === '') {
      this.getHierarchyMails();
    } else {
      this.getHierarchyMails(this.currentPage, this.searchTerm);
    }
  }

}
